export default __webpack_public_path__ + "static/media/network-goerli-logo.40d89892.svg";